import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { TopicAnswers, User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class DashboardService {

    constructor(private http: HttpClient) { }
    
    getDashboardJourney() {
        return this.http.get<any>(`${environment.apiUrl}/dashboard/my/courses-progress`);
    }

    getJourneyTasks() {
        return this.http.get<any>(`${environment.apiUrl}/users/my/journey`);
    }

    getMyStatus() {
        return this.http.get<any>(`${environment.apiUrl}/users/my/status`);
    }

    getUserStatus(id) {
        return this.http.get<any>(`${environment.apiUrl}/users/${id}/status`);
    }

    getSectors() {
        return this.http.get<any>(`${environment.apiUrl}/sectors/`);
    }

    //nearnothstarts
    getnorthnearstarscourse() {
        return this.http.get<any>(`${environment.apiUrl}/dashboard/my/northnearstarts`);
    }
}